/* eslint-disable no-param-reassign */

import Vue from 'vue'
import Vuex from 'vuex'
// import VuexPersistence from 'vuex-persist'
import axios from 'axios'
import { getField, updateField } from 'vuex-map-fields'
// import router from './router'
// import i18n from './plugins/i18n'

Vue.use(Vuex)

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage
// })

// Define the user Object
const userObject = {
  firstName: '',
  plan: '',
  email: '',
  password: '',
  terms: false,
  companyName: '',
  title: '',
  name: '',
  phone: '',
  birthDate: '',
  country: '',
  region: '',
  street: '',
  streetNumber: '',
  postalCode: '',
  city: '',
  shopURL: '',
  industry: '',
  vatID: '',
  taxID: '',
  companyIBAN: '',
  swiftbic: '',
  accountHolder: '',
  uploadIdCard: '',
  uploadAddressProof: '',
  uploadComReg: '',
  regComCheck: ''
}

export default new Vuex.Store({
  state: {
    user: userObject,
    token: '',
    ui: {
      footer: ''
    },
    plans: {
      single: { name: 'Single account', id: 'sgacc' },
      business: { name: 'Business account', id: 'bsacc' },
    }
  },
  getters: {
    getField
  },
  mutations: {
    updateFirstName(state, firstName) {
      state.user.firstName = firstName
    },
    updateUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    },
    setFooter(state, footer) {
      state.ui.footer = footer
    },
    updateField
  },
  actions: {
    getTokenId({ commit }, request) {
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      return axios.post(process.env.VUE_APP_START_ENDPOINT, request, { headers }).then((res) => {
        window.location.href = res.data;
      })
    },
    getFooter({ commit }) {
      axios({
        method: 'get',
        url: process.env.VUE_APP_FOOTER_ENDPOINT
      }).then((res) => {
        commit('setFooter', res.data.id)
      })
    }
  },
  // plugins: [vuexLocal.plugin]
});
